import { motion } from "framer-motion";

import { Container, Title, Text, GradientText } from "../Greeting/styles";
import { Link } from "react-router-dom";

const Instructor = () => (
  <Container>
    <motion.div
      initial="offscreen"
      animate="onscreen"
      variants={{
        offscreen: { opacity: 0, x: -50 },
        onscreen: { opacity: 1, x: 0 },
      }}
      transition={{ duration: 0.6 }}
      viewport={{ amount: 0.8 }}
    >
      <Title>Teaching Assistant</Title>
      <Text>
        As a Teaching Assistant at{" "}
        <Link
          className="link"
          to="https://www.carolinacodeschool.org"
          target="_blank"
        >
          Carolina Code School
        </Link>
        , I mentored 15+ full-stack bootcamp students in React, JavaScript,
        Python, and Django through project-based learning — from first lines of
        code to capstone projects. I led debugging sessions, code reviews, and
        project scoping to improve student outcomes and code quality.
      </Text>
      <Link
        to="https://www.carolinacodeschool.org"
        target="_blank"
        className="link"
      >
        <GradientText>Carolina Code School</GradientText>
      </Link>

      <div className="tech-icon-container">
        <div className="tech-icons">React</div>
        <div className="tech-icons">Javascript</div>
        <div className="tech-icons">Python</div>
        <div className="tech-icons">Django</div>
      </div>
    </motion.div>
  </Container>
);
export default Instructor;
